import type { CommandType } from '@festina/life-general-types/life'
import type { ExcludeString, Optional } from '@festina-life/core'
import type { ComponentType } from 'react'

import { AddAccessGroupAnnotationCommand } from './AddAccessGroupAnnotationCommand'
import { AmendAccessGroupAnnotationCommand } from './AmendAccessGroupAnnotationCommand'
import type { AnnotationCommandProps } from './annotationCommandTypes'
import { RemoveAccessGroupAnnotationCommand } from './RemoveAccessGroupAnnotationCommand'

type AnnotationCommandType = Extract<
  ExcludeString<CommandType>,
  `${string}AccessGroupAnnotation`
>

const commandsByCommandType: Record<
  AnnotationCommandType,
  ComponentType<AnnotationCommandProps>
> = {
  addAccessGroupAnnotation: AddAccessGroupAnnotationCommand,
  amendAccessGroupAnnotation: AmendAccessGroupAnnotationCommand,
  removeAccessGroupAnnotation: RemoveAccessGroupAnnotationCommand,
}

const isAnnotationCommandType = (
  commandType: Optional<string>,
): commandType is AnnotationCommandType =>
  !!commandType && commandType in commandsByCommandType

export const AnnotationCommand = (props: AnnotationCommandProps) => {
  const { eventVersionWithCommand } = props

  if (!eventVersionWithCommand) {
    return (
      <>
        <AddAccessGroupAnnotationCommand {...props} />
        <AmendAccessGroupAnnotationCommand {...props} />
        <RemoveAccessGroupAnnotationCommand {...props} />
      </>
    )
  }

  const commandType = eventVersionWithCommand.commandVersion?.commandType
  if (!isAnnotationCommandType(commandType)) {
    return null
  }

  const Command = commandsByCommandType[commandType]

  return <Command {...props} />
}
